import { AxiosPromise } from "axios";
import { axios } from '../axios';
import { IStockProduct } from "./types";
import { getSearchFilter } from "../../app/utils";

export const getStock = (
  query: { siteId: string, searchFilter: string }
): AxiosPromise<IStockProduct[]> => {
  return axios.get(`/stock?siteId=${query.siteId}&withProductSummary=1${getSearchFilter(query.searchFilter, "q")}`);
}

export const exportToCSV = (siteId: number): AxiosPromise<string> => {
  return axios.get(`/stock?siteId=${siteId}&format=csv`);
}